module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_05@2x-5b8e77bb15be1da21f1acb0f9e21202f.jpg";